"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function About() {
    return (react_1.default.createElement("div", { id: "about-us" },
        react_1.default.createElement("div", { id: "description" },
            react_1.default.createElement("hr", null),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { className: "red" },
                    react_1.default.createElement("b", null, "We are FYRE")),
                " (FIRST Young Robotics Engineers),",
                react_1.default.createElement("span", { className: "orange" }, "team #5480"),
                ", a FIRST FRC robotics team based in Reno, Nevada. ",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("span", { className: "grey" }, "Formed in 2013"),
                " with our rookie year in 2015, FYRE is a",
                react_1.default.createElement("span", { className: "red" }, "community high school"),
                " team with members from public and private schools in the Reno Area, such as Davidson Academy, Galena High School, Reno High School, Bishop Manogue Catholic High School, and homeschooling."),
            react_1.default.createElement("hr", null)),
        react_1.default.createElement("div", { id: "photos" },
            react_1.default.createElement("img", { src: "1fa532ee34abbc9a948d.png" }))));
}
exports.default = About;
